<template>
  <button
    :class="{ 'is-favorite': isFavorite }"
    class="favorite flex items-center justify-center min-h-8 min-w-8 size-full object-cover rounded-md cursor-pointer outline-1 outline outline-transparent focus:outline-brand focus:hover:outline-transparent"
    :data-test-id="generateDataTestId(dataTestId, 'button')"
    @click.stop="onFavoriteClick(!isFavorite)"
  >
    <AM3Icon
      type="star-filled"
      :aria-hidden="true"
    />
    <span class="sr-only">
      {{ isFavorite ? 'Unmark as favorite' : 'Mark as favorite' }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { generateDataTestId } from '@/components/am3-generic/core/dataTestId'
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'

const props = defineProps({
  dataTestId: {
    type: String,
    default: 'favorite',
  },
})

const isFavorite = defineModel<boolean>({ default: false })

function onFavoriteClick(newValue: boolean) {
  isFavorite.value = newValue
}
</script>

<!-- SVG color styling - Tailwind doesn't handle these well -->
<style lang="css">
.favorite svg path {
  fill: #e7e5e4 ;
}

.favorite:focus svg path,
.favorite:hover svg path {
  fill: theme('colors.secondary');
}

.favorite.is-favorite svg path {
  fill: #FACC15;
}

.favorite.is-favorite:hover svg path  {
  fill: #EAB308;
}
</style>
